import React,{useState} from 'react';
const endpoint='/internal/smartpdv/pilot/device/pair';
export default function DeviceActivationPilot({accessToken}){
 const [deviceId,setDeviceId]=useState(''),[code,setCode]=useState('');
 const [busy,setBusy]=useState(false),[notice,setNotice]=useState('');
 async function call(action){
  setBusy(true);setNotice('');
  try{
   const r=await fetch(endpoint,{method:'POST',credentials:'same-origin',cache:'no-store',
    headers:{authorization:'Bearer '+accessToken,'content-type':'application/json'},
    body:JSON.stringify({action,device_id:deviceId.trim(),...(action==='claim'?{code:code.trim().toLowerCase()}:{})})});
   const data=await r.json().catch(()=>({}));
   if(!r.ok)throw Error(
    r.status===403?'Acesso negado: confirme vínculo, licença e autorização no terminal.':
    data.error||'Ativação não concluída.');
   setCode('');
   setNotice(action==='claim'?
    'Navegador pareado para pré-vendas. Não habilita cobrança nem emissão fiscal.':
    'Credencial conferida no servidor. Pré-vendas dependem das permissões das empresas.');
  }catch(e){setNotice(e.message)}finally{setBusy(false)}
 }
 return <section className="panel" aria-label="Ativar este dispositivo">
  <h2>Ativar este computador ou celular</h2>
  <p>Faça login com sua própria conta. Digite o identificador e o código temporário
   entregue pelo gestor. A ativação será validada para as empresas autorizadas.</p>
  <label>ID do equipamento cadastrado<input value={deviceId} onChange={e=>setDeviceId(e.target.value)}
   placeholder="Identificador do terminal" autoComplete="off" spellCheck={false}/></label>
  <label>Código temporário<input value={code} onChange={e=>setCode(e.target.value)}
   placeholder="Código de uso único" autoComplete="off" spellCheck={false}/></label>
  <div>
   <button type="button" disabled={busy||!deviceId||code.length!==64}
    onClick={()=>call('claim')}>Ativar este navegador</button>
   <button type="button" disabled={busy||!deviceId} onClick={()=>call('check')}>
    Conferir dispositivo</button>
  </div>
  {notice&&<p role="status">{notice}</p>}
  <small>Vínculo válido por no máximo 30 dias, revogável imediatamente pelo administrador.
   Não é atestado físico do aparelho; o vínculo é com este navegador e sua conta.</small>
 </section>;
}
